import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { HTMLProps } from 'react';

import { c } from '@bedc/client/utils';

import { Icon } from './Icon';

export type LoadingSpinnerProps = Omit<HTMLProps<HTMLDivElement>, 'size'> & {
	/** Whether spinner centers on the page, or within its container. */
	type?: 'global' | 'local' | 'inline';

	/** Alternate size of the spinner. */
	size?: '3xs' | '2xs' | 'xs' | 'sm';

	/** Any text to display underneath the spinner. */
	text?: string;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
	type = 'global',
	size,
	text,

	...divProps
}) => {
	// Template
	// ------------------------------------------------------------------------

	return (
		<div
			{...divProps}
			className={c(
				type === 'global' && 'fixed inset-0',
				type === 'local' && 'absolute inset-0',
				type === 'inline' && 'inline-flex',
				'flex flex-col gap-2 items-center justify-center',
				'overflow-hidden z-50',
				'pointer-events-none',
				divProps.className
			)}
		>
			<Icon
				className={c('text-accent')}
				icon={faCircleNotch}
				spin
				size={
					size === '3xs'
						? 'sm'
						: size === '2xs'
							? 'lg'
							: size === 'xs'
								? '2x'
								: size === 'sm'
									? '4x'
									: '8x'
				}
			/>
			{text && <span>{text}</span>}
		</div>
	);
};
